module.exports = __webpack_public_path__ + "img/advertisersingup.182ac094.svg";